import { formatDistanceToNow, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'

function toDate (dateInput: string | Date): Date {
  return typeof dateInput === 'string' ? parseISO(dateInput) : dateInput
}

export function humanizeDate (dateInput: string | Date | undefined): string {
  if (!dateInput) {
    return '-'
  }
  return formatDistanceToNow(toDate(dateInput), {
    addSuffix: true,
    includeSeconds: false,
    locale: fr,
  })
}

export function formatDate (dateInput: string | Date | undefined): string {
  if (!dateInput) {
    return '-'
  }
  return toDate(dateInput).toLocaleString('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'medium',
  })
}
